import React from 'react';

export function MenuSurface({ menuRef, menuPosition, children }) {
  return (
    <div
      ref={menuRef}
      className="task-node__drag-menu"
      style={{
        position: 'fixed',
        top: menuPosition.top,
        left: menuPosition.left,
        zIndex: 10000,
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}

export function MenuItem({ icon, label, shortcut, onClick, danger, nested, type }) {
  const className = [
    'task-node__drag-menu-item',
    danger ? 'task-node__drag-menu-item--delete' : '',
    nested ? 'task-node__drag-menu-item--nested' : '',
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={className} onClick={onClick}>
      <span className="task-node__drag-menu-icon">{icon}</span>
      <span className="task-node__drag-menu-label">{label}</span>
      {shortcut ? <span className="task-node__drag-menu-shortcut">{shortcut}</span> : null}
    </button>
  );
}
